import { Observable } from 'rxjs';
import { JsonApiResource } from '@irian-ro/abstract-resource';
import { Inject, Injectable, Optional } from '@angular/core';
import { AddressDTO, DelAddressDtoModel } from '@well/address-management-domain-model';
import {
  AddressSaveTemplateServiceInterface,
  LocalAddressSearchServiceTaken,
} from '@well/address-management/data-access';
import { RomanianAddressEnum } from './romanian-address.enum';

@Injectable()
export class AddressTemplateService {
  private partnerLegalEntityUuid: string = null;

  private sectors = ['SECTOR1', 'SECTOR2', 'SECTOR3', 'SECTOR4', 'SECTOR5', 'SECTOR6'];

  constructor(
    @Inject(LocalAddressSearchServiceTaken)
    @Optional()
    private addressSaveTemplateServiceInterface: AddressSaveTemplateServiceInterface
  ) {}

  saveAddressTemplate(address: AddressDTO): Observable<JsonApiResource<DelAddressDtoModel, any>> {
    return this.addressSaveTemplateServiceInterface.saveTemplateAddress(address, this.partnerLegalEntityUuid);
  }

  getSectors() {
    return this.sectors;
  }

  isBucharestAddress(address: AddressDTO, additionalCondition = true) {
    return (
      address.country === RomanianAddressEnum.RO &&
      (address.state === RomanianAddressEnum.BUCURESTI ||
        address.state === RomanianAddressEnum.Bucuresti ||
        address.state === RomanianAddressEnum.BUCHAREST) &&
      (address.city === RomanianAddressEnum.BUCHAREST ||
        address.city === RomanianAddressEnum.BUCURESTI ||
        additionalCondition)
    );
  }
}
